<template>
  <SubHeader></SubHeader>
  <Breadcrumbs :page-name="$route.name"></Breadcrumbs>

  <!-- main -->
  <main class="404-page flex-grow-1">
    <!-- content -->
    <div class="content py-4">
      <div class="container px-4 px-sm-3">
        <h1>This page doesn't exist</h1>
      </div>
    </div>
    <!-- /content -->
  </main>
  <Footer></Footer>
  <!-- /main -->
</template>

<script setup>
import Footer from "@/components/Footer.vue";

import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";

import SubHeader from "@/components/SubHeader.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

// SEO
const siteData = reactive({
  title: "Page not found | GBIN",
  // description: "...",
});

useHead({
  title: computed(() => siteData.title),
  meta: [
    {
      name: `description`,
      content: computed(() => siteData.description),
    },
  ],
});
</script>
